import React, { useState, useEffect, useCallback } from "react";
import NodeList from "./NodeList";
import { useNodesServiceClient } from "../../services/brainflex/NodesServiceClient";
import type { ContextNode, GetNodesOutput } from "../../services/brainflex/NodesServiceClient";
import ServiceTransaction from "../../services/ServiceTransaction";
import { useLanguageSelection } from "../../contexts/LanguageSelectionContext";

const Nodes: React.FC = () => {
  // State
  const [nodes, setNodes] = useState<ContextNode[]>([]);

  // Context
  const { languageSelection } = useLanguageSelection();
  
  // Other
  const nodesServiceClient = useNodesServiceClient();

  const fetchNodes = useCallback(async () => {
    try {
      const transaction: ServiceTransaction<GetNodesOutput> = await nodesServiceClient.getNodes(
        "en",
        languageSelection?.language ?? "",
        languageSelection?.locale ?? "",
        languageSelection?.voice ?? ""
      );
      if (transaction.response.isSuccess) {
        setNodes(transaction.response.success?.data?.nodes ?? []);
      }
      else {
        // handle error
      }
    } catch (error) {
      console.error("Error fetching nodes:", error);
    }
  }, [languageSelection, nodesServiceClient]);

  useEffect(() => {
    if (languageSelection) {
      fetchNodes();
    }
  }, [languageSelection, fetchNodes]);

  return (
    <div>
      <NodeList nodes={nodes} onRequestListRefresh={fetchNodes} />
    </div>
  );
};

export default Nodes;